import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const L=i("vietnam",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M24 4.5L0 4.5L0 20.5L24 20.5L24 4.5Z"
                fill="#DA251D" />
            <path
                d="M12.0001 7.70117L9.17613 16.3812L16.5681 11.0212L7.43213 11.0212L14.8241 16.3812L12.0001 7.70117Z"
                fill="#FFFF00" />
        </svg>
    `),p=i("vietnam_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_85983)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M30 0.5L-6 0.5L-6 24.5L30 24.5L30 0.5Z"
                    fill="#DA251D" />
                <path
                    d="M12.0004 5.2998L7.76444 18.3198L18.8524 10.2798L5.14844 10.2798L16.2364 18.3198L12.0004 5.2998Z"
                    fill="#FFFF00" />
            </g>
            <defs>
                <clipPath id="clip0_19470_85983">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{L as Vietnam,p as VietnamRounded};
